// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cert-card {
  width: 30%;
  display: inline-block;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 5px;
  margin-bottom: 30px;
  flex: 0 0 30%;
  transition: all 0.2s ease-in-out;
}

.cert-header {
  margin: 0px;
  border-radius: 5px 5px 0px 0px;
}

.logo_img {
  margin: 3px;
  width: auto;
  height: 100px;
}

.cert-body {
  margin: 0px;
}

.cert-body-title {
  font-family: "Google Sans Regular";
  font-size: 20px;
  margin: 10px;
}

.cert-body-subtitle {
  font-family: "Google Sans Regular";
  font-size: 18px;
  color: #808080;
  margin: 10px;
}

.content {
  position: relative;
  width: 100%;
  margin: auto;
  overflow: hidden;
}

.content .content-overlay {
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  height: 99%;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  transition: all 0.4s ease-in-out 0s;
}

.content-details {
  position: absolute;
  text-align: center;
  padding-left: 1em;
  padding-right: 1em;
  width: 100%;
  top: 50%;
  left: 50%;
  opacity: 0;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease-in-out 0s;
}

.content:hover .content-details {
  top: 50%;
  left: 50%;
  opacity: 1;
}

.content-details h3 {
  color: #fff;
  font-weight: 500;
  font-family: "Google Sans Regular";
  letter-spacing: 0.15em;
  margin-bottom: 0.5em;
  text-transform: uppercase;
}

.fadeIn-top {
  top: 20%;
}

@media (max-width: 768px) {
  .cert-card {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/certificationCard/CertificationCard.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,UAAU;EAGV,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,UAAU;EAGV,gCAAgC;EAGhC,mCAAmC;AACrC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".cert-card {\n  width: 30%;\n  display: inline-block;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  border-radius: 5px;\n  margin-bottom: 30px;\n  flex: 0 0 30%;\n  transition: all 0.2s ease-in-out;\n}\n\n.cert-header {\n  margin: 0px;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.logo_img {\n  margin: 3px;\n  width: auto;\n  height: 100px;\n}\n\n.cert-body {\n  margin: 0px;\n}\n\n.cert-body-title {\n  font-family: \"Google Sans Regular\";\n  font-size: 20px;\n  margin: 10px;\n}\n\n.cert-body-subtitle {\n  font-family: \"Google Sans Regular\";\n  font-size: 18px;\n  color: #808080;\n  margin: 10px;\n}\n\n.content {\n  position: relative;\n  width: 100%;\n  margin: auto;\n  overflow: hidden;\n}\n\n.content .content-overlay {\n  background: rgba(0, 0, 0, 0.7);\n  position: absolute;\n  height: 99%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  opacity: 0;\n  -webkit-transition: all 0.4s ease-in-out 0s;\n  -moz-transition: all 0.4s ease-in-out 0s;\n  transition: all 0.4s ease-in-out 0s;\n}\n\n.content-details {\n  position: absolute;\n  text-align: center;\n  padding-left: 1em;\n  padding-right: 1em;\n  width: 100%;\n  top: 50%;\n  left: 50%;\n  opacity: 0;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  -webkit-transition: all 0.3s ease-in-out 0s;\n  -moz-transition: all 0.3s ease-in-out 0s;\n  transition: all 0.3s ease-in-out 0s;\n}\n\n.content:hover .content-details {\n  top: 50%;\n  left: 50%;\n  opacity: 1;\n}\n\n.content-details h3 {\n  color: #fff;\n  font-weight: 500;\n  font-family: \"Google Sans Regular\";\n  letter-spacing: 0.15em;\n  margin-bottom: 0.5em;\n  text-transform: uppercase;\n}\n\n.fadeIn-top {\n  top: 20%;\n}\n\n@media (max-width: 768px) {\n  .cert-card {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
